import React, { useEffect, useState } from "react";
import BeatstagePlayback from "../components/BeatstagePlayback";
import loadLevel from "../loadLevel";

export default function PlayLevel() {
  const [encoded, setEncoded] = useState<string | null>(null);
  const [audio, setAudio] = useState<Blob | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const { artist, song } = (() => {
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      if (pathParts.length >= 3 && pathParts[0] === "play") {
        return {
          artist: decodeURIComponent(pathParts[1]),
          song: decodeURIComponent(pathParts[2]),
        };
      }
      const params = new URLSearchParams(window.location.search);
      return {
        artist: params.get("artist"),
        song: params.get("song"),
      };
    })();

    if (!artist || !song) {
      setError("Missing artist or song identifier");
      return;
    }

    void loadLevel(`${artist}/${song}`)
      .then(({ data, audio }) => {
        const encoded = btoa(JSON.stringify(data));
        const blob = new Blob([audio]);
        setEncoded(encoded);
        setAudio(blob);
      })
      .catch((err: Error) => {
        setError(err.message);
      });
  }, []);

  if (error) {
    return <div className="p-4 text-red-500">{error}</div>;
  }
  if (!encoded || !audio) {
    return <div className="p-4">Loading...</div>;
  }
  return <BeatstagePlayback encoded={encoded} audio={audio} />;
}

